module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('speed-stages', {
    attrs: {
      "filterUser": _vm.filterUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e9da2d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AMDashboard/speed.vue
// module id = 2204
// module chunks = 0